mmf_modules.define('utils/utils',[
    'require',
    'underscore'
],
function (
    require,
    _
) {
    'use strict';

    var utils = {};

    // return true if the value represents a number
    // Number instances and Number strings (eg, `"5"`) return `true`
    // Everything else (non-numeric strings, booleans, nulls, objects,
    //      and undefined) all return `false`
    utils.isNumber = function (value) {
        return (
            value !== false &&
                value !== true &&
                value !== null &&
                !(_.isString(value) && !value.match(/\d/)) &&
                !isNaN(value - 0) // catches undefined and objects
            );
    };

    // return true if the value represents an integer
    utils.isInt = function (value) {
        return utils.isNumber(value) && parseInt(value, 10) === parseFloat(value);
    };

    utils.parseAndNormalizeDecimal = function (dec) {
        var i = 0;
        return dec.replace(/\./g, function (all, match) {
            return i++ === 0 ? '.' : '';
        });
    };

    // Simple number padding function.
    // Initial purpose is for Google Analytics event label so times can be sorted easily as strings
    // num. number. required.
    // int_len. int. required.
    // fractional_len. int. optional. default 0
    utils.padNum = function (num, int_len, fractional_len) {
        if (!utils.isNumber(num)) {
            return num;
        }
        // don't accept negatives for now
        if (num < 0) {
            return num;
        }
        fractional_len = fractional_len || 0;
        var num_parts = String(num).split('.');
        var int_part = '0000000000' + num_parts[0];
        var fractional_part = (num_parts.length === 2 ? num_parts[1] : '') + '0000000000';
        var result = int_part.substr(int_part.length - int_len);

        if (fractional_len > 0) {
            result += ('.' + fractional_part.substr(0, fractional_len));
        }

        return result;
    };

    // transform floating point number by trimming trailing floating point noise
    //      which commonly results from arithmetic operations.
    // **value**: floating point number or string
    // **max_decimals**: Number. Maximum number of decimals to include in returned value
    //      default 5.
    // Example:
    //      utils.trimFloat(4.1500000000001); // 4.15
    //      utils.trimFloat(3.14159265, 3); // 3.142
    utils.trimFloat = function (value, max_decimals) {
        max_decimals = utils.isInt(max_decimals) ? max_decimals : 5;
        return Number(Number(value).toFixed(max_decimals));
    };


    // Copied from legacy code and inserted here for testing ... if this is here but not used then please remove
    utils.secondsToTime = function (totalSec) {
        if (!totalSec) {
            return '00:00:00';
        } else {
            var hours = parseInt(totalSec / 3600, 10) % 24,
                minutes = parseInt(totalSec / 60, 10) % 60,
                seconds = parseInt(totalSec % 60, 10);
            return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds  < 10 ? '0' + seconds : seconds);
        }
    };

    // First call returns a function that will output the moving average over `period` occurrences each time the
    //      resulting function is called with a number
    utils.simpleMovingAverage = function (period) {
        var nums = [];
        return function (num) {
            if (utils.isNumber(num) && utils.isNumber(period)) {
                nums.push(num);
                if (nums.length > period) {
                    nums.splice(0, 1);
                }  // remove the first element of the array

                return _.reduce(nums, function (memo, num) {
                    return memo += num;
                }, 0) / nums.length;
            }
            return 0;
        };
    };

    // return the parameter if present, else throw a ReferenceError
    utils.assert = function (param, message) {
        message = message || 'Missing required parameter';

        if (typeof param === 'undefined') {
            throw new ReferenceError(message);
        }
        return param;
    };

    // Return the value of the cookie with the provided name.
    utils.getCookie = function getCookie (c_name) {
        var i,
            len,
            x,
            y,
            ARRcookies = document.cookie.split(';');

        for (i = 0, len = ARRcookies.length; i < len; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            if (x === c_name) {
                return window.decodeURIComponent(y);
            }
        }
    };

    // Set a cookie in the browser with the provided name, value, expiration, and path
    // returns cookie value
    utils.setCookie = function setCookie (name, value, utc_expiration_date, path) {
        path = path || '/';
        var cookie_parts = [[name, value].join('=')];

        if (utc_expiration_date) {
            cookie_parts.push(
                [ 'expires', utc_expiration_date.toUTCString() ].join('=')
            );
        }
        cookie_parts.push([ 'path', path ].join('='));
        document.cookie = cookie_parts.join('; ');
        return value;
    };

    var QueryString = {
        'Stored': '',
        'All': function () {
            if (QueryString.Stored) {
                return QueryString.Stored;
            } else {
                var query_string = {},
                    query = window.location.search.substring(1),
                    vars = query.split('&'),
                    pair,
                    arr,
                    i,
                    len;

                for (i = 0, len = vars.length; i < len; i++) {
                    pair = vars[i].split('=');
                    // If first entry with this name
                    if (typeof query_string[pair[0]] === 'undefined') {
                        query_string[pair[0]] = pair[1];
                        // If second entry with this name
                    } else if (typeof query_string[pair[0]] === 'string') {
                        arr = [ query_string[pair[0]], pair[1] ];
                        query_string[pair[0]] = arr;
                        // If third or later entry with this name
                    } else {
                        query_string[pair[0]].push(pair[1]);
                    }
                }
                QueryString.Stored = query_string;
                return query_string;
            }
        },
        'Get': function (url_param) {
            var qs_list = QueryString.All();

            if (qs_list[url_param]) {
                return qs_list[url_param];
            } else {
                return undefined;
            }
        }
    };
    utils.QueryString = QueryString;

    /**
     * Performs a shallow (non-deep) conversion of JSON to query-string
     * Eg. {foo: 1, bar: true, dog: "woof"} -> "foo=1&bar=true&dog=woof"
     * @param {Object} json
     */
    utils.param = function (json) {
        var k,
            o = '';

        for (k in json) {
            if (json.hasOwnProperty(k)) {
                o += k + '=' + json[k] + '&';
            }
        }
        return o.substr(0, o.length - 1);
    };

    /**
     * Extends an object with any number of other objects. Shallow or deep.
     * Deep copy is a more complex algorithm. Don't use it if you don't need it.
     *
     * @author: matt.steitle@mapmyfitness.com
     *
     * Params:
     * {Boolean} deep OPTIONAL first parm to designate a deep extend
     *     (combines objects and deal with nested objects).
     * {Object} target The first object argument will be the target object to extend
     * {Object} source All additional objects will be used to extend the target object.
     *     Priority is given to consecutive source objects.
     *
     * @example: extend(true, target, source);
     * @example: extend(target, source, source);
     * @example: extend(true, target, source, source, source);
     */
    utils.extend = function (/* {Boolean} deep, {Object} target, {Object} source1 [,...{Object} sourceN] */) {
        var deep = false,
            target,
            sources,
            i;

        if (typeof arguments[0] === 'boolean') {
            deep = arguments[0];
            target = arguments[1];
            sources = Array.prototype.slice.call(arguments, 2);
        }
        else {
            target = arguments[0];
            sources = Array.prototype.slice.call(arguments, 1);
        }

        var extend = function (deep, target, source) {
            var prop;

            for (prop in source) {
                if (source.hasOwnProperty(prop)) {
                    if (deep) {
                        if (target.hasOwnProperty(prop)) {
                            if (typeof target[prop] === 'object') {
                                if (typeof source[prop] === 'object') {
                                    target[prop] = extend(deep, target[prop], source[prop]);
                                    continue;
                                }
                            }
                        }
                    }
                    // else for all nested conditions
                    target[prop] = source[prop];
                }
            }
            return target;
        };

        for (i in sources) {
            if (sources.hasOwnProperty(i)) {
                target = extend(deep, target, sources[i]);
            }
        }
        return target;
    };

    utils.setOptions = function (obj, options) {
        obj.options = utils.extend({}, obj.options, options);
        return obj.options;
    };

    /**
     * Wraps call to require so it can load built module or not built module AND
     *   accept an export value from the module required
     * @author: ryan.schutte@mapmyfitnessinc.com
     *
     * @param {String} name REQUIRED
     * @param {Object} url REQUIRED
     * @param {Object} onLoadCallback OPTIONAL DEFAULT no-op
     *
     * @example: utils.lazyRequire(
     *     'app/qs/device_priority/main',
     *     '/public/modules/app/qs/device_priority/main.js',
     *     function (exported_value) {
     *         // now have access to whatever is returned by
     *         exported_value.method()
     *     }
     * );
     */
    utils.lazyRequire = function (name, url, onLoadCallback) {
        onLoadCallback = onLoadCallback || function () {};
        require([url], function (apps_export) {
            if (!apps_export) {
                // nest this call to require since using 'insertRequire' config option on module
                //  doesn't allow for a callback
                require([name], onLoadCallback);
            } else {
                onLoadCallback(apps_export);
            }
        });
    };

    utils.resolveObjectReferenceFromString = function getValue (obj, path) {
        return _.reduce(path.split('.'), function (obj, name) {
            return obj && obj[name];
        }, obj);
    };

    return utils;
});
